import React from 'react';
import { UndraggableImage } from 'components/shared/UndraggableImage';
import HFTLogo from 'assets/hft-logo.png';
import JIKAClub from 'assets/jika-club.png';
import VerticalDivider from 'assets/vertical-divider.png';
import { Flex, Link } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const AnimatedFlex = motion(Flex);

export const LogoImage = React.memo(() => {
  return (
    <Link
      href="https://www.hungfooktong.com/"
      target="_blank"
      _focus={{ border: 'none' }}
    >
      <AnimatedFlex
        alignItems="center"
        p={{ base: 4, md: 6 }}
        whileTap={{ scale: 0.9 }}
        transition={{ duration: 0.1 }}
      >
        <UndraggableImage
          src={HFTLogo}
          maxHeight={{ base: '40px', md: '60px' }}
        />
        <UndraggableImage
          pl={2}
          pr={2}
          src={VerticalDivider}
          maxHeight={{ base: '40px', md: '60px' }}
        />
        <UndraggableImage
          src={JIKAClub}
          maxHeight={{ base: '40px', md: '60px' }}
        />
      </AnimatedFlex>
    </Link>
  );
});
